import React, { Component } from "react";
import { withRouter } from 'react-router-dom';

import { withStyles } from "@material-ui/core/styles";
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from "@material-ui/core/CardContent";
import ApplicationItemForm from "./ApplicationItemForm";
import AppItemStore from "../../stores/AppItemStore";
// import DeviceStore from "../../stores/DeviceStore";
// import DeviceForm from "../devices/DeviceForm";


const styles = {
  card: {
    overflow: "visible",
  },
};


class UpdateApplicationItem extends Component {
  constructor() {
    super();
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(applicationItem) {
    AppItemStore.update(applicationItem, resp => {
      this.props.history.push(`/organizations/${this.props.match.params.organizationID}/applications/${this.props.match.params.applicationID}`);
    });
  }

  render() {
    return(
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Card className={this.props.classes.card}>
            <CardContent>
              <ApplicationItemForm
                submitLabel="Update item"
                object={this.props.applicationItem}
                onSubmit={this.onSubmit}
                match={this.props.match}
                update={true}
                disabled={!this.props.admin}
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles)(withRouter(UpdateApplicationItem));
